
export const GAME_STATUS = {
  'C': 'Complete',
  'P': 'Playing',
  'D': 'Dropped',
  'B': 'Back Log',
  'W': 'Wish List',
  'H': 'Hold',
};
